import * as z from 'zod';

export const FollowMemberRequest = z.object({
  memberId: z
    .string()
    .describe('ID of the member to follow.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
});
export const FollowMemberResponse = z.object({});
export const UnfollowMemberRequest = z.object({
  memberId: z
    .string()
    .describe('ID of the member to unfollow.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
});
export const UnfollowMemberResponse = z.object({});
export const ListCurrentMemberFollowingRequest = z.object({
  options: z
    .object({
      paging: z
        .object({
          limit: z
            .number()
            .int()
            .describe(
              'Number of items to return. See [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging).'
            )
            .min(1)
            .max(100)
            .optional()
            .nullable(),
          cursor: z
            .string()
            .describe('Cursor returned from last query response.')
            .optional()
            .nullable(),
        })
        .describe(
          'Pagination options. For more information, see\n[Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging).'
        )
        .optional(),
    })
    .optional(),
});
export const ListCurrentMemberFollowingResponse = z.object({
  memberIds: z.array(z.string()).optional(),
  metadata: z
    .object({
      count: z
        .number()
        .int()
        .describe('Number of items starting from given cursor.')
        .optional()
        .nullable(),
      cursors: z
        .object({
          next: z
            .string()
            .describe(
              'Cursor string pointing to the next page in the list of results.'
            )
            .max(16000)
            .optional()
            .nullable(),
          prev: z
            .string()
            .describe(
              'Cursor pointing to the previous page in the list of results.'
            )
            .max(16000)
            .optional()
            .nullable(),
        })
        .describe(
          'Cursors to navigate through the result pages using `next` and `prev`.'
        )
        .optional(),
    })
    .describe('Details on the paged set of results returned.')
    .optional(),
});
export const ListMemberFollowingRequest = z.object({
  memberId: z
    .string()
    .describe('ID of the member whose followers to list.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
  options: z
    .object({
      paging: z
        .object({
          limit: z
            .number()
            .int()
            .describe(
              'Number of items to return. See [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging).'
            )
            .min(1)
            .max(100)
            .optional()
            .nullable(),
          cursor: z
            .string()
            .describe('Cursor returned from last query response.')
            .optional()
            .nullable(),
        })
        .describe(
          'Pagination options. For more information, see\n[Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging).'
        )
        .optional(),
    })
    .optional(),
});
export const ListMemberFollowingResponse = z.object({
  memberIds: z.array(z.string()).optional(),
  metadata: z
    .object({
      count: z
        .number()
        .int()
        .describe('Number of items starting from given cursor.')
        .optional()
        .nullable(),
      cursors: z
        .object({
          next: z
            .string()
            .describe(
              'Cursor string pointing to the next page in the list of results.'
            )
            .max(16000)
            .optional()
            .nullable(),
          prev: z
            .string()
            .describe(
              'Cursor pointing to the previous page in the list of results.'
            )
            .max(16000)
            .optional()
            .nullable(),
        })
        .describe(
          'Cursors to navigate through the result pages using `next` and `prev`.'
        )
        .optional(),
    })
    .describe('Details on the paged set of results returned.')
    .optional(),
});
export const ListCurrentMemberFollowersRequest = z.object({
  options: z
    .object({
      paging: z
        .object({
          limit: z
            .number()
            .int()
            .describe(
              'Number of items to return. See [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging).'
            )
            .min(1)
            .max(100)
            .optional()
            .nullable(),
          cursor: z
            .string()
            .describe('Cursor returned from last query response.')
            .optional()
            .nullable(),
        })
        .describe(
          'Pagination options. For more information, see\n[Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging).'
        )
        .optional(),
    })
    .optional(),
});
export const ListCurrentMemberFollowersResponse = z.object({
  memberIds: z.array(z.string()).optional(),
  metadata: z
    .object({
      count: z
        .number()
        .int()
        .describe('Number of items starting from given cursor.')
        .optional()
        .nullable(),
      cursors: z
        .object({
          next: z
            .string()
            .describe(
              'Cursor string pointing to the next page in the list of results.'
            )
            .max(16000)
            .optional()
            .nullable(),
          prev: z
            .string()
            .describe(
              'Cursor pointing to the previous page in the list of results.'
            )
            .max(16000)
            .optional()
            .nullable(),
        })
        .describe(
          'Cursors to navigate through the result pages using `next` and `prev`.'
        )
        .optional(),
    })
    .describe('Details on the paged set of results returned.')
    .optional(),
});
export const ListMemberFollowersRequest = z.object({
  memberId: z
    .string()
    .describe('ID of the member whose followed members to list.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
  options: z
    .object({
      paging: z
        .object({
          limit: z
            .number()
            .int()
            .describe(
              'Number of items to return. See [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging).'
            )
            .min(1)
            .max(100)
            .optional()
            .nullable(),
          cursor: z
            .string()
            .describe('Cursor returned from last query response.')
            .optional()
            .nullable(),
        })
        .describe(
          'Pagination options. For more information, see\n[Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging).'
        )
        .optional(),
    })
    .optional(),
});
export const ListMemberFollowersResponse = z.object({
  memberIds: z.array(z.string()).optional(),
  metadata: z
    .object({
      count: z
        .number()
        .int()
        .describe('Number of items starting from given cursor.')
        .optional()
        .nullable(),
      cursors: z
        .object({
          next: z
            .string()
            .describe(
              'Cursor string pointing to the next page in the list of results.'
            )
            .max(16000)
            .optional()
            .nullable(),
          prev: z
            .string()
            .describe(
              'Cursor pointing to the previous page in the list of results.'
            )
            .max(16000)
            .optional()
            .nullable(),
        })
        .describe(
          'Cursors to navigate through the result pages using `next` and `prev`.'
        )
        .optional(),
    })
    .describe('Details on the paged set of results returned.')
    .optional(),
});
export const QueryCurrentMemberConnectionsRequest = z.object({
  connectedMemberIds: z.array(z.string()).max(100),
});
export const QueryCurrentMemberConnectionsResponse = z.object({
  connectedMembers: z
    .array(
      z.object({
        connectedMemberId: z
          .string()
          .describe('Site member ID.')
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional(),
        followedByMember: z
          .boolean()
          .describe(
            'Whether the listed member is followed by the given member.'
          )
          .optional(),
        followingMember: z
          .boolean()
          .describe('Whether the listed member follows the given member.')
          .optional(),
      })
    )
    .optional(),
});
export const QueryMemberConnectionsRequest = z.object({
  memberId: z
    .string()
    .describe('Member ID.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
  connectedMemberIds: z.array(z.string()).max(100),
});
export const QueryMemberConnectionsResponse = z.object({
  connectedMembers: z
    .array(
      z.object({
        connectedMemberId: z
          .string()
          .describe('Site member ID.')
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional(),
        followedByMember: z
          .boolean()
          .describe(
            'Whether the listed member is followed by the given member.'
          )
          .optional(),
        followingMember: z
          .boolean()
          .describe('Whether the listed member follows the given member.')
          .optional(),
      })
    )
    .optional(),
});
